
/**
 *
 * http配置
 *
 */
import axios from 'axios'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { Message } from 'iview'
// 超时时间
axios.defaults.timeout = 30000
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
NProgress.configure({ showSpinner: false })// NProgress Configuration
let msg

// HTTPrequest拦截
axios.interceptors.request.use(config => {
  NProgress.start() // start progress bar
  return config
}, error => {
  return Promise.reject(error)
})

// HTTPresponse拦截
axios.interceptors.response.use(data => {
  	NProgress.done()
	return data
}, error => {
  NProgress.done();
  Message.error('发生了一个错误');
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/router/axios.js